module.exports = __webpack_public_path__ + "static/media/racquet.caf480ad.svg";